import { render, staticRenderFns } from "./Gotop.vue?vue&type=template&id=eb70364e&"
import script from "./Gotop.vue?vue&type=script&lang=js&"
export * from "./Gotop.vue?vue&type=script&lang=js&"
import style0 from "./Gotop.vue?vue&type=style&index=0&scrop=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb70364e')) {
      api.createRecord('eb70364e', component.options)
    } else {
      api.reload('eb70364e', component.options)
    }
    module.hot.accept("./Gotop.vue?vue&type=template&id=eb70364e&", function () {
      api.rerender('eb70364e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/common/components/Gotop.vue"
export default component.exports